const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const resolvePropertyId = (order = {}) => {
  if (order.property?._id) return order.property._id;
  if (order.propertyId) return order.propertyId;
  if (order.propertyID) return order.propertyID;
  if (order.property) return order.property;
  return null;
};

export const aggregateHostFeesFromOrders = (orders = []) => {
  const totals = {};

  if (!Array.isArray(orders)) return totals;

  orders.forEach((order) => {
    const propertyId = resolvePropertyId(order);
    if (!propertyId) return;

    if (!totals[propertyId]) {
      totals[propertyId] = { totalHostFee: 0, orderCount: 0 };
    }

    totals[propertyId].totalHostFee += toNumber(order?.hostFee);
    totals[propertyId].orderCount += 1;
  });

  return totals;
};

export const aggregateFromGraphEarnings = (earningsByProperty = {}) => {
  const totals = {};

  if (!earningsByProperty || typeof earningsByProperty !== "object") return totals;

  Object.entries(earningsByProperty).forEach(([propertyId, entry]) => {
    const orders = Array.isArray(entry?.orders) ? entry.orders : [];
    const hasOrderRows = orders.length > 0;

    if (hasOrderRows) {
      totals[propertyId] = {
        totalHostFee: orders.reduce((sum, order) => sum + toNumber(order?.hostFee), 0),
        orderCount: orders.length,
      };
      return;
    }

    const earningsRows = Array.isArray(entry?.earnings) ? entry.earnings : [];
    totals[propertyId] = {
      totalHostFee: earningsRows.reduce((sum, row) => {
        if (typeof row === "number") return sum + row;
        return sum + toNumber(row?.hostFee);
      }, 0),
      orderCount: earningsRows.length,
    };
  });

  return totals;
};

export const buildPropertyEarningsMap = ({ orders, earningsByProperty }) => {
  const ordersTotals = aggregateHostFeesFromOrders(orders);
  if (Object.keys(ordersTotals).length > 0) return ordersTotals;
  return aggregateFromGraphEarnings(earningsByProperty);
};
